export function publish(type, payload) {
    var event = new CustomEvent(type, { detail: payload });
    document.dispatchEvent(event);
}
//# sourceMappingURL=publish.js.map